import { useLocation } from "react-router-dom";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import AdminFormLayout from "../components/AdminFormLayout";
import ButtonComponent from "../../components/ButtonComponent";
import { apiUrl } from "../../config/api";
import { getAdminUploadHeaders } from "../../utils/adminApi";

const EditCollection = () => {
  const location = useLocation();
  const { collectionId } = location.state;
  const { collectionName } = location.state;
  const { collectionDescription } = location.state;
  const { collabTitle } = location.state;

  const handleImageChange = (e) => {
    const { name, value, files } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: name === "collectionImage" ? files[0] : value,
    }));
  };

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    collectionName: collectionName,
    collabTitle: collabTitle || "",
    collectionDescription: collectionDescription,
  });

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const productData = new FormData();
      productData.append("collectionName", formData.collectionName);
      productData.append("collabTitle", formData.collabTitle);
      productData.append(
        "collectionDescription",
        formData.collectionDescription
      );

      // If there's an image file, append it to the FormData
      if (formData.collectionImage) {
        productData.append("collectionImage", formData.collectionImage);
      }

      await axios.put(
        apiUrl(`/api/collection/${collectionId}`),
        productData,
        { headers: getAdminUploadHeaders() }
      );
      toast.success("Collection updated successfully");
      navigate("/admin/admincollections");
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Failed to update product");
    }
  };
  return (
    <AdminFormLayout title="Edit Collection" backTo="/admin/admincollections" backLabel="Back to Collections">
      <form encType="multipart/form-data">
          <div className="admin-form-group">
            <label htmlFor="collectionName">Collection Name</label>
            <input
              type="text"
              className="form-control admin-all-forms-inputs"
              id="collectionName"
              name="collectionName"
              value={formData.collectionName}
              onChange={(e) =>
                setFormData({ ...formData, collectionName: e.target.value })
              }
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="collabTitle">Collaboration Title (page heading)</label>
            <input
              type="text"
              className="form-control admin-all-forms-inputs"
              id="collabTitle"
              name="collabTitle"
              placeholder="Leave blank to auto-generate from collection name"
              maxLength={200}
              value={formData.collabTitle}
              onChange={(e) =>
                setFormData({ ...formData, collabTitle: e.target.value })
              }
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="collectionDescription">Collection Description</label>
            <textarea
              type="text"
              className="form-control admin-all-forms-inputs"
              id="collectionDescription"
              name="collectionDescription"
              style={{ height: "200px" }}
              maxLength={1700}
              value={formData.collectionDescription}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  collectionDescription: e.target.value,
                })
              }
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="collectionImage">Collection Image</label>
            <input
              type="file"
              className="form-control admin-all-forms-inputs"
              id="collectionImage"
              name="collectionImage"
              accept="image/*"
              onChange={handleImageChange}
            />
          </div>

          <ButtonComponent onClick={handleUpdate}>
            Update Collection
          </ButtonComponent>
        </form>
    </AdminFormLayout>
  );
};
export default EditCollection;
